import React from "react"
import { Flex, Tag } from "antd"
import PropTypes from "prop-types"
import { CircledClose } from "ui/Icon/DSIcon/CircledClose"
import styles from "./index.module.css"

const FilterChips = ({
  selectedValues,
  options,
  onChange,
  className,
  gap = 4,
  closeIcon,
  showWhenEmpty = false,
}) => {
  const shownValues = selectedValues?.filter((v) => v !== "all")

  if (!shownValues?.length && !showWhenEmpty) return null

  const handleRemoveValue = (value) => {
    onChange(selectedValues.filter((v) => v !== value && v !== "all"))
  }

  const defaultCloseIcon = <CircledClose width={16} height={16} fill="var(--color-primary)" />

  return (
    <Flex gap={gap} className={className} wrap>
      {shownValues.map((value) => {
        const option = options.find((o) => o.value === value)
        if (!option) return null

        return (
          <Tag
            key={value}
            className={styles.filterChip}
            bordered={true}
            closable
            closeIcon={closeIcon ? closeIcon : defaultCloseIcon}
            onClose={(e) => {
              e.preventDefault()
              handleRemoveValue(value)
            }}
          >
            {option.label}
          </Tag>
        )
      })}
    </Flex>
  )
}

FilterChips.propTypes = {
  selectedValues: PropTypes.array.isRequired,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  gap: PropTypes.number,
  closeIcon: PropTypes.node,
  showWhenEmpty: PropTypes.bool,
}

export default React.memo(FilterChips)
